<template>
  <div>
    <div v-if="readOnly">
      <div class="showitem-item">
        <div class="showitem-tile">{{ item.name }}</div>
        <div v-if="item.scoring">
          <van-rate
            void-color="#2AB1E7"
            color="#2AB1E7"
            size="26"
            gutter="14"
            v-model="rateval"
            @change="onRateChange"
          />
        </div>
      </div>
      <div class="TextCommentClass" v-if="item.textComment">
        <div class="showitem-text" v-if="item.textComment">
          <textarea
            placeholder="请输入..."
            @input="handleTextareaChange"
          ></textarea>
        </div>
        <div v-if="item.uploadFile">
          <van-uploader
            v-model="fileList"
            accept="image"
            :after-read="afterRead"
            @delete="changeDelete"
          />
        </div>
      </div>
    </div>

    <div v-else>
      <div class="showitem-item">
        <div class="showitem-tile">{{ item.name }}</div>
        <div>
          <van-rate
            void-color="#2AB1E7"
            color="#2AB1E7"
            size="26"
            gutter="14"
            :value="item.score"
          />
        </div>
      </div>
      <div class="showitem-item showitem-text" v-if="item.content">
        <textarea
          disabled
          placeholder="请输入..."
          :value="item.content"
        ></textarea>
      </div>
      <div class="showitem-item" v-if="item.files && item.files.length">
        <!-- file-list -->
        <van-uploader
          v-model="item.files"
          accept="image"
          :deletable="false"
          disabled
        />
      </div>
      <div
        class="showitem-item showitem-text showitem-comment"
        v-if="item.appendContent"
      >
        <div v-if="item.appendContent.userComment">
          用户追加：{{ item.appendContent.userComment }}
        </div>
        <div v-if="item.appendContent.merchantComment">
          商户追加：{{ item.appendContent.merchantComment }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    readOnly: {
      type: Boolean,
    },
    item: {
      type: Object,
    },
  },
  data() {
    return {
      rateval: 0,
      fileList: [],
    };
  },
  watch: {
    item(val) {
      let files = [];
      if (val.files && val.files.length > 0) {
        val.files.map((item) => {
          files.push({
            url: item,
          });
        });
        val.files = files;
      }
    },
  },
  computed: {},
  mounted() {
    let files = [];
    if (this.item.files && this.item.files.length > 0) {
      this.item.files.map((item) => {
        files.push({
          url: item,
        });
      });
      this.item.files = files;
    }
  },
  methods: {
    afterRead(e) {
      this.$emit("changeUploadImg", e);
    },
    changeDelete(file, e) {
      console.log(file, e, "s");
      this.$emit("deleteImg", e.index);
    },
    handleTextareaChange(e) {
      this.$emit("changeText", e.target.value);
    },
    onRateChange(e) {
      // console.log("changeSorce", e);
      this.$emit("changeSorce", e);
    },
  },
};
</script>

<style lang="scss" scoped>
.showitem-item {
  margin-top: 12px;
  display: flex;
  align-items: center;
  .showitem-tile {
    font-size: 18px;
    margin-right: 6px;
    color: rgb(86, 90, 72);
    font-weight: bold;
  }
}
.TextCommentClass {
  border: 1px solid #ccc;
  padding: 18px;
  border-radius: 5%;
  width: 280px;
  min-height: 220px;
}
.showitem-text {
  color: #333;
  font-size: 16px;
  textarea {
    border: none;
    width: 100%;
    height: 120px;
  }
}
.showitem-comment {
  margin-top: 14px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: start;
}
</style>